import React from 'react';
import { Container } from 'semantic-ui-react';
import 'semantic-ui-less/definitions/elements/container.less';

export default Container;
